import { render, staticRenderFns } from "./loading_bg.vue?vue&type=template&id=b0772fcc&"
import script from "./loading_bg.vue?vue&type=script&lang=js&"
export * from "./loading_bg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports